import React from 'react';
import { ConnectedRouter } from 'connected-react-router'
import './index.css';
import Routes from './routes';
import { Provider } from 'react-redux';
import store, { history } from './store';
import ZoomContext from './context/zoom-context';

import ZoomVideo from '@zoom/videosdk';
import { socket, SocketContext } from './context/socket';
const zmClient = ZoomVideo.createClient();

const App = () => {
    return (
        <Provider store={store}>
        <ZoomContext.Provider value={zmClient}>
          <SocketContext.Provider value={socket}>
            <ConnectedRouter history={history} >
  
              <Routes />
            </ConnectedRouter>
          </SocketContext.Provider>
        </ZoomContext.Provider>
      </Provider>
    )
}

export default App;